import {INVALID_PHONE_NUMBER} from "./constants";
import {translate} from '../i18n/translate.js';
export const MANDATORY_MEMBER_FIELDS = {
    'Email' : translate('Please enter email address'),
    'FirstName': translate('Please enter first name'),
    'LastName': translate('Please enter last name'),
    'PrimaryPhone': translate('Please enter primary phone'),
    'AddressLine1': translate('Please enter address line'),
    'ZipCode': translate('Please enter zip/postal code'),
    'City': translate('Please enter city')};
export const MEMBER_FIELDS_NO_FB = {
    'Password': translate('Please enter at least 6 characters'),
    'RetypedPassword': translate('Please retype your password')};

export const MEMBER_ERROR_VALIDATION_MESSAGE = {
    "invalidEmail": translate("Invalid email"),
    "invalidPassword": translate("Please enter at least 6 characters"),
    "invalidRetypedPassword": translate("The password does not match"),
    "invalidPrimaryPhone": INVALID_PHONE_NUMBER,
    "invalidSecondaryPhone": INVALID_PHONE_NUMBER,
    "invalidZipCode": translate("Invalid zip code"),
    "invalidPartnerEmail": translate('Invalid email'),
    'invalidPartnerPhone': INVALID_PHONE_NUMBER
};

export const NOT_MANDATORY_MEMBER_FIELDS = {
    "SecondaryPhone": INVALID_PHONE_NUMBER,
    "PartnerPhone":"",
    "PartnerEmail":""
};


// WEBPACK FOOTER //
// ./src/common/contactDetailsConstants.js